import React from 'react';

import { PACKAGE_HOME_PATH } from '../../store/constants';

import RedirectToPage from '../../components/RedirectToPage';
import OrderSuccess from '../../components/OrderSuccess';

import { Container } from '../styles';
import type { PropsFromRedux } from '.';

export const OrderSuccessRoute = (props: PropsFromRedux) => {
  const { redirectToHome, isMobile } = props;

  if (redirectToHome) {
    return <RedirectToPage path={PACKAGE_HOME_PATH} />;
  }

  return (
    <Container $isMobile={isMobile}>
      <OrderSuccess />
    </Container>
  );
};
